export default __webpack_public_path__ + "384f8c00b028d958d1b688494774485a.png";